import { useState } from "react";
import { Form } from "react-bootstrap";

import { FilterPopover, useFilterPopover } from "./filterPopover";

export const EnumColumnFilter = ({
	column: { filterValue, setFilter, enumOptions },
}: {
	column: {
		filterValue?: string;
		setFilter?: (value?: string) => void;
		enumOptions: Record<string, string>;
	};
}) => {
	const popover = useFilterPopover();
	const [selected, setSelected] = useState<Set<string>>(new Set());

	const handleSelect = (value: string) => {
		setSelected((prev) => {
			const next = new Set(prev);
			if (next.has(value)) {
				next.delete(value);
			} else {
				next.add(value);
			}
			return next;
		});
	};

	const handleApply = () => {
		if (selected.size === 0) {
			setFilter?.();
			popover.setHasActiveFilter(false);
			popover.close();
			return;
		}
		setFilter?.([...selected].join("||"));
		popover.setHasActiveFilter(true);
		popover.close();
	};

	const handleClear = () => {
		setSelected(new Set());
		setFilter?.();
		popover.setHasActiveFilter(false);
		popover.close();
	};

	return (
		<FilterPopover
			popoverId="popover-enum-filter"
			minWidth="240px"
			maxWidth="320px"
			applyDisabled={selected.size === 0 && !popover.hasActiveFilter}
			onApply={handleApply}
			onClear={handleClear}
			popoverState={popover}
		>
			<div className="d-flex flex-column gap-1">
				{Object.entries(enumOptions).map(([value, label]) => (
					<Form.Check
						key={value}
						type="checkbox"
						id={`enum-filter-${value}`}
						label={label}
						checked={selected.has(value)}
						onChange={() => handleSelect(value)}
					/>
				))}
			</div>
		</FilterPopover>
	);
};
